import HttpService from "@/services/HttpService";

export default {
  namespaced: true,

  state: {
    status: null,
    loaded: false,
  },

  mutations: {
    SET_STATUS(state, payload) {
      state.status = payload;
      state.loaded = true;
    },
  },

  actions: {
    async fetchStatus({ state, commit }) {
      if (state.loaded) return;
      try {
        const res = await HttpService.get("/ai-assisted-status");
        commit("SET_STATUS", res?.data?.data ?? res?.data ?? {});
      } catch (error) {
        console.error("Failed to fetch ai-assisted-status", error);
      }
    },
  },

  getters: {
    status: (s) => s.status ?? {},
    loaded: (s) => s.loaded,
  },
};
